import {Subject} from 'rxjs';

import IInteractionPayload from '../../../Analytics/Interactions/Interfaces/IInteractionPayload';
import StoreName           from '../../Shared/Constants/StoreName';
import IPlayerState        from '../../Shared/Interfaces/IPlayerState';

import createPlaybackActionsResolver from './createPlaybackActionsResolver';
import IPlayback                     from './Interfaces/IPlayback';
import IPlaybackStore                from './Interfaces/IPlaybackStore';
import Playback                      from './Playback';

const createPlaybackStore = (
    state: IPlayerState,
    interactions$: Subject<IInteractionPayload>,
    initialValue: IPlayback = {}
): IPlaybackStore => {
    const resolvePlaybackActions = createPlaybackActionsResolver(interactions$);

    return state.createStore({
        name: StoreName.PLAYBACK,
        model: Playback,
        actions: resolvePlaybackActions
    }, initialValue);
};

export default createPlaybackStore;
